import { useMemo } from 'react';
import { useAdminAuth } from '../contexts/AdminAuthContext';

/**
 * Custom hook to manage admin user state from AdminAuthContext.
 * Replaces duplicated admin user loading logic across components.
 */
const useAdminUser = () => {
  const { adminUser, login, logout, loading } = useAdminAuth();

  const role = adminUser?.role?.trim().toLowerCase();

  const { isAdmin, isEmployee, isStaff } = useMemo(() => ({
    isAdmin: role === 'admin',
    isEmployee: role === 'employee',
    isStaff: role === 'admin' || role === 'employee',
  }), [role]);

  return { adminUser, isAdmin, isEmployee, isStaff, login, logout, loading };
};

export default useAdminUser;
